import { css } from 'styled-components';

import { media } from '../../lib/StyledComponents';
import { cssDeclaration } from '../_ThemeTwo_/Utils';

type VALID_INPUT_ICONS = 'secure' | 'dollar' | 'calendar';

export interface IInputProps {
  alert?: boolean;
  icon?: VALID_INPUT_ICONS;
  maxWidth?: string;
}

export const commonInputStyles = css<IInputProps>`
  width: 100%;
  padding: ${({ theme: { input } }) => input.padding};
  position: relative;
  background-color: ${({ theme: { input } }) => input.colorBackground};
  transition: all 0.1s ease-out;
  border: ${({ theme: { input } }) => input.borderWidth} solid ${({ theme: { input } }) => input.colorBorder};
  border-radius: ${({ theme: { input } }) => input.borderRadius};
  outline: none;

  &:focus,
  &:hover {
    border: ${({ theme: { input } }) => input.borderWidth} solid ${({ theme: { input } }) => input.colorFocus};
    box-shadow: ${({ theme: { input } }) => input.boxShadowHover};
  }

  &::placeholder {
    color: ${({ theme: { input } }) => input.colorPlaceholder};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colorSlate5};
  }

  ${({ theme: { brand, input }, alert }) => alert && css`
    border: ${input.borderWidth} solid ${brand.colorAlert};
    box-shadow: ${input.boxShadowAlert};

    &:hover {
      border: ${input.borderWidth} solid ${brand.colorAlert};
      box-shadow: ${input.boxShadowAlert};
    }

    ${input.state && input.state.error && css`
      color: ${input.state.error.colorText && input.state.error.colorText};
    `}
  `}

  ${({ theme, alert }) => {
    const { input } = theme;

    return css`
      color: ${input.colorText && input.colorText};


      ${input.borderData && css`
        border: none;
        /* border */ ${cssDeclaration(theme.themeTwo, 'border', input.borderData)};
      `}

      ${input.state && css`
        ${input.state.hover && css`
          &:hover {
            /* border */ ${input.state.hover.border && cssDeclaration(theme.themeTwo, 'border', input.state.hover.border)};
          }
        `}

        ${input.state.focus && css`
          &:focus {
            /* outline */ ${input.state.focus.outline && cssDeclaration(theme.themeTwo, 'outline', input.state.focus.outline)};
            /* border */ ${input.state.focus.border && cssDeclaration(theme.themeTwo, 'border', input.state.focus.border)};
          }
        `}

        ${input.state.error && alert && css`
          color: ${input.state.error.colorText && input.state.error.colorText};
          /* border */ ${input.state.error.border && cssDeclaration(theme.themeTwo, 'border', input.state.error.border)};
        `}
      `}
    `;
  }}

  ${props => css`
    ${media.small`
      ${props.maxWidth && `max-width: ${props.maxWidth};`}
    `}
  `}
`;
